import Vue from 'vue';
import VueI18n from 'vue-i18n';
import '@/utils/mouse-event';
import './element-ui';
import Navigation from 'vue-navigation';
import App from './App.vue';
import router from './router';
import './router/permission';
import store from './store';
import '@/utils/export';
import Cookie from '@/utils/cookie';
import Message from '@/utils/message';
import '@/utils/network';
import permission from '@/utils/permission';
import ReadOnly from '@/directive/permission';
import NumberOnly from '@/directive/number-only';
import zh from '@/lang/zh';
import en from '@/lang/en';
import './scss/element-variables.scss';
import './scss/index.scss';

Vue.config.productionTip = false;

Vue.use(Navigation, { router, store, keyName: 'key' });

// 判断只读函数
Vue.use(permission);

// 判断只读指令
Vue.use(ReadOnly);
// 只能输入数字指令
Vue.use(NumberOnly);
Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: Cookie.get('lanConfig') ? Cookie.get('lanConfig') : 'zh', // 定义默认语言为中文
  messages: {
    zh, // 语言包所在的文件位置
    en
  }
});

Vue.prototype.$message = Message;

new Vue({
  i18n, // 中英文挂在到vue
  router,
  store,
  render: h => h(App)
}).$mount('#app');